"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralsControllerMySummaryV1200Response = instanceOfReferralsControllerMySummaryV1200Response;
exports.ReferralsControllerMySummaryV1200ResponseFromJSON = ReferralsControllerMySummaryV1200ResponseFromJSON;
exports.ReferralsControllerMySummaryV1200ResponseFromJSONTyped = ReferralsControllerMySummaryV1200ResponseFromJSONTyped;
exports.ReferralsControllerMySummaryV1200ResponseToJSON = ReferralsControllerMySummaryV1200ResponseToJSON;
exports.ReferralsControllerMySummaryV1200ResponseToJSONTyped = ReferralsControllerMySummaryV1200ResponseToJSONTyped;
var ReferralSummaryResponseDto_1 = require("./ReferralSummaryResponseDto");
/**
 * Check if a given object implements the ReferralsControllerMySummaryV1200Response interface.
 */
function instanceOfReferralsControllerMySummaryV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ReferralsControllerMySummaryV1200ResponseFromJSON(json) {
    return ReferralsControllerMySummaryV1200ResponseFromJSONTyped(json, false);
}
function ReferralsControllerMySummaryV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, ReferralSummaryResponseDto_1.ReferralSummaryResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function ReferralsControllerMySummaryV1200ResponseToJSON(json) {
    return ReferralsControllerMySummaryV1200ResponseToJSONTyped(json, false);
}
function ReferralsControllerMySummaryV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, ReferralSummaryResponseDto_1.ReferralSummaryResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
